import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SchoolProgramActivityModel } from 'src/shared/models/school-program-activity-model';
import { AuthService } from 'src/shared/services/auth.service';
import { CoachService } from 'src/shared/services/coach.service';
import { FileService } from 'src/shared/services/file.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { SchoolProgramService } from 'src/shared/services/school-program.service';
import { TranslateService } from 'src/shared/services/translate.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-coach-list',
  templateUrl: './coach-list.component.html',
  styleUrl: './coach-list.component.scss'
})
export class CoachListComponent implements OnInit {

  @ViewChild('addCoach', {static: true}) public modalAddCoach: NgbModalRef;

  dataCoach: MatTableDataSource<any>;
  checkApiRun: Subscription;
  paramForm: FormGroup;
  modalForm: FormGroup;
  schoolActivities: any;
  disabledAddCoach = true;
  countryList = [];
  nationalityList = [];
  religionList = [];
  nationalityTypeList = ['KTP', 'PASSPORT'];
  genderList = ['female', 'male'];
  maritalStatusList = ['single', 'married', 'divorced', 'widow/er'];
  province = [];
  imageSrc: any;
  profileFile: File;

  columnsToDisplay = ['coach_name', 'activity', 'coach_fee'];

  constructor(private schoolProgramService: SchoolProgramService,
              private coachService: CoachService,
              private router: Router,
              private route: ActivatedRoute,
              private fileService: FileService,
              private modalService: NgbModal,
              private translate: TranslateService,
              private rpSer: ResponseService,
              public auth: AuthService
            ) { }

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    if (this.auth.permissions['SCHOOL_PROGRAM_COACH_EDIT'] || this.auth.permissions['SCHOOL_PROGRAM_COACH_DELETE'] || this.auth.permissions['SCHOOL_PROGRAM_COACH_VIEW']) {
      this.columnsToDisplay.push('action');
    }
    this.translate.load('extracurricular', 'coach');
    this.initForm();
    this.initModalForm();
  }

  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_program_category_id': new FormControl(null),
      'school_program_activity_id': new FormControl(null),
      // 'year_level_id': new FormControl(null)
    });
  }

  // onChangeAcademicYear(item: any) {
  //   this.paramForm.controls['academic_year'].markAsTouched();
  //   this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

  //   this.paramForm.controls['school_location_id'].setValue(null);
  // }

  onChangeSchoolLevel(item: any) {
    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    // this.paramForm.controls['year_level_id'].setValue(null);
    if (item) {
      this.getCoachData();
    }
  }

  onChangeSchoolProgram(item: any) {
    this.paramForm.controls['school_program_id'].markAsTouched();
    this.paramForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

    this.paramForm.controls['school_program_category_id'].setValue(null);
    // if (item){
    //   this.getSchoolActivities();
    // }
  }

  onChangeSchoolProgramCategory(item: any) {
    this.paramForm.controls['school_program_category_id'].markAsTouched();
    this.paramForm.controls['school_program_category_id'].setValue(item ? item.school_program_category_id : null);
    // if (item){
    //   this.getSchoolActivities();
    // }
  }

  getSchoolActivities () {
      if (this.checkApiRun) {
        this.checkApiRun.unsubscribe();
      }
      this.checkApiRun = this.schoolProgramService.getSchoolProgramActivity({
        academic_year: this.paramForm.get('academic_year')?.value,
        school_program_id: this.paramForm.get('school_program_id')?.value,
        school_program_category_id: this.paramForm.get('school_program_category_id')?.value,
        year_level_id: this.paramForm.get('year_level_id')?.value,
        approved: true
      }).subscribe(
        (res: any) => {
          if (res.status) {
            this.schoolActivities = res.data.slice();
          } else {
            this.rpSer.showAddError(res.message ? res.message : 'An unexpected error occurred. Please check your connection and try again.');
          }
        },
        (error) => {
          this.rpSer.showAddError();
        });
    }

  getCoachData() {
    if (this.checkApiRun) {
      this.checkApiRun.unsubscribe();
    }
    this.checkApiRun = this.coachService.getCoachList(this.paramForm.get('school_location_id')?.value).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.dataCoach = new MatTableDataSource(res.data);
        } else {
          this.rpSer.showAddError(res.message ? res.message : 'An unexpected error occurred. Please check your connection and try again.');
        }
      },
      error: (err: any) => {
        this.rpSer.showAddError();
      }
    });
  }

  onViewProfileCoach(userId: number) {
    this.router.navigate(['detail/' + userId], { relativeTo: this.route });
  }

  onOpenModalAddCoach() {
    this.modalForm.reset();
    this.coachService.getReligionList().subscribe({next: (response: any) => { if (response.error === 0) { this.religionList = response.result.data } }});
    this.coachService.getNationalityList().subscribe({next: (response: any) => { if (response.error === 0) { this.nationalityList = response.result.data } }});
    this.coachService.getCountryList().subscribe({next: (response: any) => { if (response.error === 0) { this.countryList = response.result.data } }});
    this.modalService.open(this.modalAddCoach, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg',
    }).result.then((result: any) => {

    }, (reason: any) => {

    });
  }

  readURL(event: any): void {
    if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        this.profileFile = event.target.files[0];

        const reader = new FileReader();
        reader.onload = e => this.imageSrc = reader.result;

        reader.readAsDataURL(file);
    }
}

  initModalForm() {
    this.modalForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'username': new FormControl(null),
      'email': new FormControl(null),
      'fullname': new FormControl(null),
      'gender': new FormControl(null),
      'date_of_birth': new FormControl(null),
      'place_of_birth': new FormControl(null),
      'religion_id': new FormControl(null),
      'nationality_id': new FormControl(null),
      'nationality_id_type': new FormControl(null),
      'nationality_id_number': new FormControl(null),
      'npwp': new FormControl(null),
      'marital_status': new FormControl(null),
      'phone_number': new FormControl(null),
      'cellular_number': new FormControl(null),
      'alternative_email_address': new FormControl(null),
      'country_id': new FormControl(null),
      'province_id': new FormControl(null),
      'city': new FormControl(null),
      'full_address': new FormControl(null),
      'postal_code': new FormControl(null),
      'coach_fee': new FormControl(null),
      'bank_account': new FormControl(null),
      'account_number': new FormControl(null),
      'account_holder_name': new FormControl(null),
      'bank_office_brand': new FormControl(null),
      'institute_name': new FormControl(null),
      'institute_office_number': new FormControl(null),
      'institute_email_address': new FormControl(null),
      'institute_address': new FormControl(null),
      'coach_photo_pathfile': new FormControl(null),
      'coach_remarks': new FormControl(null),
    });
  }

  test() {
    console.log(this.modalForm.value);
  }

  onChangeAcademicYearModal(item: any) {
    this.modalForm.controls['academic_year'].markAsTouched();
    this.modalForm.controls['academic_year'].setValue(item ? item.academic_year : null);

    this.modalForm.controls['school_location_id'].setValue(null);
    this.trackAddCoachChanges()
  }

  onChangeSchoolLevelModal(item: any) {
    this.modalForm.controls['school_location_id'].markAsTouched();
    this.modalForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.modalForm.controls['school_level_id'].markAsTouched();
    this.modalForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);
    this.trackAddCoachChanges()
  }

  trackAddCoachChanges() {
    this.disabledAddCoach = !this.modalForm.controls['school_location_id'].value ||
                            !this.modalForm.controls['school_level_id'].value ||
                            !this.modalForm.controls['username'].value ||
                            !this.modalForm.controls['fullname'].value ||
                            !this.modalForm.controls['email'].value ||
                            !this.modalForm.controls['date_of_birth'].value||
                            !this.modalForm.valid;
  }

  getProvince() {
    const country_id = this.modalForm.get('country_id')?.value;
    this.province = [];
    this.coachService.getProvince({
      country_id: country_id || null
    })
    .subscribe((response: any) => {
      if (response['error'] === 0) {
        this.province = response['result']['data'].slice();
      }
    });
  }

  onDeleteCoach(userId: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteCoach(userId);
      }
    })
  }

  deleteCoach(userId: number) {
    if (this.checkApiRun) {
      this.checkApiRun.unsubscribe();
    }
    this.checkApiRun = this.coachService.deleteCoach({user_id: userId}).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.modalService.dismissAll();
          this.rpSer.showDeleteSuccess('Coach successfully deleted'); 
          this.getCoachData();
        } else {
          this.rpSer.showDeleteFailed(res.message ? res.message : 'An unexpected error occurred. Please check your connection and try again.');
        }
      },
      error: (err: any) => {
        this.rpSer.showDeleteFailed();
      }
    });
  }

  async onSaveCoach() {
    if (this.checkApiRun) {
      this.checkApiRun.unsubscribe();
    }
    if (this.profileFile) {
      const profileFile = await this.fileService.uploadFileS3(this.profileFile, 'school_program/coach');
      const fileParams = { name: profileFile.name, path: profileFile.path, url: profileFile.url, size: profileFile.size };
      this.modalForm.controls['coach_photo_pathfile'].setValue(fileParams.path);
      if (fileParams.size > 5000000) {
        Swal.fire({
          title: 'Warning',
          text: 'File exceed maximum limit of 5MB',
          icon: 'warning'
        });
        return;
      };
    }
    this.checkApiRun = this.coachService.addCoach(this.modalForm.value).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.modalService.dismissAll();
          this.rpSer.showAddSuccess('Coach successfully added');  
          if (this.paramForm.get('school_location_id')?.value) {
            this.getCoachData();
          }
        } else {
          this.rpSer.showAddError(res.message ? res.message : 'An unexpected error occurred. Please check your connection and try again.');
        }
      },
      error: (err: any) => {
        this.rpSer.showAddError();
      }
    });
  }

}
